import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FmSystemListStateService {

  private changeSource = new Subject<boolean>();

  fmSystemListStateChanged$ = this.changeSource.asObservable();

  constructor() {
  }

  fmSystemListStateChanged(fmSystemListStateChanged: boolean) {
    this.changeSource.next(fmSystemListStateChanged);
  }
}
